import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import {
  ContentWrapper,
  UploaderHeading,
  UploaderLabel,
  UploaderLink,
} from './styles';

type IdleStateProps = {
  onUploadFile: (uploadedFile: File) => void;
};

export const IdleState = ({ onUploadFile }: IdleStateProps) => {
  const [dragging, setDragging] = useState(false);

  const acceptedFileTypes = 'audio/*,video/*';

  const openFilePicker = (e: React.FormEvent, open: () => void) => {
    e.preventDefault();
    open();
  };

  const handleOnDrop = (acceptedFiles: File[]) => {
    setDragging(false);
    onUploadFile(acceptedFiles[0]);
  };

  return (
    <Dropzone
      onDrop={handleOnDrop}
      accept={acceptedFileTypes}
      noClick
      noKeyboard
      onDragEnter={() => setDragging(true)}
      onDragLeave={() => setDragging(false)}
    >
      {({ getRootProps, getInputProps, open }) => {
        return (
          <ContentWrapper {...getRootProps()}>
            <input {...getInputProps()} />
            {dragging ? (
              <UploaderHeading>Needs design!</UploaderHeading>
            ) : (
              <div>
                <UploaderHeading>
                  Drag & drop files here to upload, or{' '}
                  <UploaderLink onClick={e => openFilePicker(e, open)}>
                    browse
                  </UploaderLink>
                  .
                </UploaderHeading>
                <UploaderLabel>Supports [.mp4, .wav, .mov]</UploaderLabel>
              </div>
            )}
          </ContentWrapper>
        );
      }}
    </Dropzone>
  );
};
